module.exports = __webpack_public_path__ + "img/12th_financial-wellness.f0abc2ac.webp";